import React, { Component } from "react";
var formState;

function NewCustomerDetailScreen(props, state) {
    let formState = state;
    formState.email = sessionInfo.emails;

    return (

        <center>
            <form id="emailForm" name="emailForm" className="contact-form">
                <table><thead></thead><tbody><tr><td>
                    <label style={{ position: 'relative', top: '5px' }}>OEM:</label></td><td>
                        <input type="text" className="form-control" name="oem" id="oem" value={formState.oem} onChange={handleOemChange}/>
                    </td></tr>
                    <tr><td>
                        <label style={{ position: 'relative', top: '5px' }}>Phone number:</label></td><td>
                            <input type="text" className="form-control" name="phone" id="phone" value={formState.phone} onChange={handlePhoneChange}/>
                        </td></tr>
                    <tr><td>
                        <label style={{ position: 'relative', top: '5px' }}>Role:</label></td><td>
                            <select className="row-sm-6 refInput form-control mr-2" id="selectRole" onChange={handleRoleChange}>
                                <option value="" selected disabled>Select</option>
                                <option value="Parts Managers">Parts Managers</option>
                                <option value="Parts Associate">Parts Associate</option>
                                <option value="OEM Field Rep">OEM Field Rep</option>
                                <option value="OEM Corporate">OEM Corporate</option>
                                <option value="Other">Other</option>
                            </select>
                        </td></tr>
                    <tr><td>
                        <label style={{ position: 'relative', top: '5px' }}>Dealer code:</label></td><td>
                            <input type="text" className="form-control" name="dealer" id="dealer" value={formState.dealer} onChange={handleDealerChange}/>
                        </td></tr>
                    <tr><td>
                        <label style={{ position: 'relative', top: '5px' }}>Do you require training? (Y/N):</label></td><td>
                            <select className="row-sm-6 refInput form-control mr-2" id="training">
                                <option value="" selected disabled>Select</option>
                                <option value="Y">Yes</option>
                                <option value="N">No</option>
                            </select>
                            <input type="hidden" className="form-control" name="email" id="email" value={formState.email} onChange={handleEmailChange} />
                        </td></tr></tbody></table>
                <div id="message" className='error'>{formState.message}</div><br />
                <button
                    className="btn btn-secondary searchParts"
                    data-dismiss="modal"
                    onClick={event => {
                        event.preventDefault();
                        handleSubmit(event);
                    }}

                >
                    Submit
                </button>
            </form>
        </center>
    );

}

function saveUserData() {
    try {
        const response = fetch('api/SelectDealer/SaveUserInfo', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ NewUserFormSubmitted: true})
            })
        let data = response;
        if (data.status === 200) {
            console.log("Response: " + data.status)

        }
    } catch (err) {
        const error = new Error(err);
    }
}

function handleSubmit(event) {
    document.getElementById('message').innerText = "";

    if (document.getElementById('oem').value == "") {
        document.getElementById('message').innerText = 'Please enter your oem information';
        return false;
    }
    if (document.getElementById('phone').value == "") {
        document.getElementById('message').innerText = 'Please enter phone number'
        return false;
    }
    if ((document.getElementById('dealer').value == "") && (document.getElementById("dealer").disabled == false)) {
        document.getElementById('message').innerText = 'Please enter your dealer'
        return false;
    }
    if (document.getElementById('selectRole').value == "") {
        document.getElementById('message').innerText = 'Please enter your role information';
        return false;
    }
    if (document.getElementById('training').value == "") {
        document.getElementById('message').innerText = 'Please enter your training information';
        return false;
    }

    sendEmail();
}


const handleOemChange = ({ target }) => {
    let val = target.value;
}
const handlePhoneChange = ({ target }) => {
    let val = target.value;
}
const handleEmailChange = ({ target }) => {
    let val = target.value;
}
const handleDealerChange = ({ target }) => {
    let val = target.value;
}
const handleRoleChange = ({ target }) => {
    let val = target.value;
    if (val.includes("OEM")) {
        document.getElementById('dealer').value = "";
        document.getElementById("dealer").disabled = true;
    }
    else {
        document.getElementById("dealer").disabled = false;
    }
}

function sendEmail() {

    saveUserData();

    var toEmailType = "";

    toEmailType = "support";

    var subject = "New User - Additional User Information";
    var body = "OEM: " + document.getElementById('oem').value + "<br />" +
        "Phone: " + document.getElementById('phone').value + "<br />" +
        "Email: " + (sessionInfo?.emails || '') + "<br />" +
        "Role: " + document.getElementById('selectRole').value + "<br />" +
        "Dealer: " + document.getElementById('dealer').value + "<br />" +
        "Training: " +  document.getElementById('training').value

    var emailToList = [];

    const formData = new FormData();
    formData.append('ToAddresses', emailToList)
    formData.append('Subject', subject)
    formData.append('Body', body)
    formData.append('SupportEmailType', toEmailType)

    fetch('api/SupportLinks/SendSupportEmail', {
        method: 'POST',
        body: formData
    }

    ).then((pageName) => window.location.href = pageName)
        .catch((error) => {
            const err = new Error(error);
        });

}

export default NewCustomerDetailScreen;